import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { ClockCircleOutlined } from '@ant-design/icons';

import { isEmpty } from 'lodash';

import RibbonButton from 'common/components/button/RibbonButton';
import Messages from 'i18n/messages/home';
import { forwardTo } from 'utils/common/route';

import gridSelector from 'common/components/grid-view/controllers/selectors';

import { useGetProductFullView } from 'hooks';

const HistoryControl = () => {
  const { id: productId } = useParams();

  const selectedItems = useSelector(
    gridSelector.makeSelectDetailCurrentITemsSelection()
  );

  const { productFull: currentProduct } = useGetProductFullView({ productId });

  const disableButton = selectedItems?.length !== 1 && isEmpty(currentProduct);

  const id =
    selectedItems?.length === 1
      ? selectedItems[0]?.id
      : !isEmpty(currentProduct)
        ? currentProduct?.productId
        : undefined;

  return (
    <RibbonButton
      icon={<ClockCircleOutlined />}
      label={Messages.versions}
      onClick={() => forwardTo(`/product/versions/${id}`)}
      disabled={disableButton}
    />
  );
};

HistoryControl.propTypes = {};

export default HistoryControl;
